import axios from "axios";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { InitialState } from "state/InitialState";
import { FileTypes } from "state/types/UserTypes";
import { UiActions } from "../UiActions";

// ----------------------------------------------------------------------
/**
 * Contém todas as actions necessárias para gerenciar arquivos.
 *
 * @type {Object}
 * @since 0.0.1
 */
export const FileActions = {};

FileActions.upload = (formData, callback) => {
  return (dispatch, getState) => {

    const state = getState();
    const { data } = state.token

    axios.post(process.env.REACT_APP_GB_API_ROOT + "/file/upload",     
    formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': data.Authorization
      }, 
      mode: 'no-cors'
    }).then(response => {      
      dispatch(UiActions.publishSuccessAlert("Imagem enviada"));
      if(callback){
        callback(response)
      }
    }).catch(error => {
      dispatch(UiActions.publishErrorAlert(  error.message
        ? error.message 
        : "Erro ao enviar a imagem"));

        if(callback){
          callback(error)
        }
    });  

    
  }
}

FileActions.remove = (fileName, callback) =>{
  return (dispatch, getState) => {

  const state = getState();
  const { data } = state.token;
  
  ExecuteRequest(
    GlamboxEndpoints.HandleFile.delete,
    Object.assign(
      {},
      {
        fileName,
      }
    ),
    "POST",
    {
      Authorization: data.Authorization
    },
    null,
    (response) => {
      const {
        result,
        statusCode
      } = response;
          
      dispatch(FileActions.pending(false));

      if (statusCode === 200) {
        dispatch(FileActions.success(true));
      }else{
        dispatch(FileActions.error(
            (result && result.message) 
              ? result.message 
              : "Erro")
        );
      }

      if(callback){
        callback(response);
      }
    });
  }
}

FileActions.get = (subscriberId, callback) =>{
  return (dispatch, getState) => {

    const state = getState();
    const { data } = state.token;
  
    ExecuteRequest(
      GlamboxEndpoints.HandleFile.getUploaded,
      Object.assign(
        {},
        {
          subscriberId
        }
      ),
      "GET",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        const {
          result,
          statusCode
        } = response;

        dispatch(FileActions.pending(false));

        if (statusCode === 200) {
          dispatch(FileActions.success(true));
        }else{
          dispatch(FileActions.error(
              (result && result.message) 
                ? result.message 
                : "Erro")
          );
        }

        if(callback){
          callback(response);
        }
      }
    );
  }
}

// ACTIONS PURAS
// ----------------------------------------------------------------------

FileActions.sync = () => ({
  files: {
    lastSync: Date.now()
  },
  type: FileTypes.sync
});

FileActions.set = (files) => ({
  files: {
    data: files,
    lastSync: Date.now()
  },
  type: FileTypes.set
});

FileActions.unset = () => ({
  files: InitialState.createSyncObject(),
  type: FileTypes.unset
});

FileActions.success = (success) => ({
  files: {
    success: (success === true)
  },
  type: FileTypes.success
});

FileActions.pending = (pending) => ({
  files: {
    pending: (pending === true)
  },
  type: FileTypes.pending
});

FileActions.error = (error) => ({
  files: {
    error
  },
  type: FileTypes.error
});